export class UserArea {
  id: number;
  name?: any;
  users: any[];
  usersAdmin: any[];
}
